<template>
  <footer class="bg-gray-100">
    <div
      class="footer-height flex w-full items-center border-t border-solid border-gray-400 py-4 tablet:py-3"
    >
      <div class="container-wrap">
        <div class="tablet:flex tablet:items-center">
          <IconLogoAdvantech class="mb-2 h-4 w-20 tablet:mb-0" />
          <p
            class="mb-2 text-sm tablet:mb-0 tablet:border-r tablet:border-solid tablet:border-gray-400 tablet:px-4"
          >
            © 1983-{{ thisYear }} Advantech Co., Ltd.
          </p>
          <p
            class="text-sm tablet:border-r tablet:border-solid tablet:border-gray-400 tablet:px-4"
          >
            <TheNuxtLink
              :to="privacyPolicyUrl"
              :title="$t('footer.privacy-policy')"
              class="font-bold hover:text-blue-400"
            >
              {{ $t('footer.privacy-policy') }}
            </TheNuxtLink>
          </p>
        </div>
      </div>
    </div>
    <div v-if="profile.hasMultipleAccounts" class="change-role-height" />
  </footer>
</template>

<script setup lang="ts">
  const dayjs = useDayjs();
  const { privacyPolicyUrl } = useWebsiteUrl();
  const profileStore = useProfileStore();
  const { profile } = storeToRefs(profileStore);

  const thisYear = computed((): string => dayjs().format('YYYY'));
</script>

<style lang="scss" scoped>
  .footer-height {
    @apply min-h-footer-mobile-height tablet:min-h-footer-height;
  }

  .change-role-height {
    @apply h-change-role-mobile-height tablet:h-change-role-height;
  }
</style>
